import { ValidationLevel } from 'ui';
import { SimpleFormValuesStoreData } from '../types';
import { SimpleFormValidationConfig, SimpleFormValidationError } from './types';

const createValidationObject = (result: SimpleFormValidationError, m: {}) => {
  return {
    level: ValidationLevel.error,
    messages: [
      ...(m[result.field]?.messages || []),
      {
        level: ValidationLevel.error,
        message: result.message
      }
    ]
  };
};

export const validate = (config: SimpleFormValidationConfig, data: SimpleFormValuesStoreData, translation: (id: number) => string) => {

  return config.reduce((m, rule) => {
    const result = rule(data, translation);

    if(Array.isArray(result)) {
      result?.map(r => m[r.field] = createValidationObject(r, m));
    }
    else if(result) {
      m[result.field] = createValidationObject(result, m);
    }
    return m;
  }, {});
};
